import {
  React,
  Grid,
  Typography,
  TitleBox,
} from '../../collections/Imports';

export const CreatePollNav = (props) => {
  const titleClass = TitleBox();
  return (
    <Grid
      container
      className={titleClass.TitleBand}
      justify="space-between"
      alignItems="center"
    >
      <Grid item sm={10}>
        <Typography variant="h5" style={{ paddingLeft: '15px' }}>
          {props && typeof props.isEditable !== 'undefined' && props.isEditable
            ? 'Edit Poll'
            : 'Create Poll'}
        </Typography>
      </Grid>

      <Grid item sm={1}>
        <Typography variant="h5" component="h2">
          1/3
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CreatePollNav;
